module.exports = __webpack_public_path__ + "roadmap-1-1x-2c5aa7a7534d765059c8ec46fb26011a.webp";